import {PageManager} from 'genesis-packages/core';
import '../../extensions/quantify/quantify-wishlist.js';
import './WISH.scss';

export default class WISH extends PageManager {

	constructor (pageContext) {

		super(pageContext);

	}

	onReady () {

		const self = this;

		if (self.pageContext.Edit_SavedItem && self.pageContext.Edit_SavedItem > 0) {
			const elem = document.getElementById('js-listitem-' + self.pageContext.Edit_SavedItem);

			if (elem) {
				let extraPadding = 0;
				const stickyHeader = document.querySelector('.js-sticky-account-header');

				if (stickyHeader) {
					extraPadding = stickyHeader.offsetHeight;
				}

				window.scroll({
					behavior: 'smooth',
					left: 0,
					top: elem.getBoundingClientRect().top - extraPadding
				});
			}
		}

	}

}
